import * as types from '../actiontypes';
import {
	API_RESOURCES,
	createApiReadAction,
	createApiUpdateAction,
	createApiDeleteAction,
	HTTP_REQUEST_METHODS,
	createApiCreateAction
} from '../../util/api';

export const getFlowChartStepById = (engagementId, flowchartId, flowchartStepId) => {
	return createApiReadAction(types.GET_FLOWCHART_STEP_BY_ID, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.FLOWCHART]: flowchartId,
		[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId
	});
};

export const editStep = (engagementId, flowChartId, flowchartStepId, patchDocument) => {
	return createApiUpdateAction(
		types.EDIT_FLOWCHART_STEP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: flowChartId,
			[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId
		},
		patchDocument,
		HTTP_REQUEST_METHODS.PATCH
	);
};

export const deleteFlowchartStep = (engagementId, flowChartId, flowchartStepId) => {
	return createApiDeleteAction(types.DELETE_FLOWCHART_STEP, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.FLOWCHART]: flowChartId,
		[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId
	});
};

export const relateWCGWToFlowChartStep = (engagementId, flowchartId, flowchartStepId, wcgwData) => {
	return createApiCreateAction(
		types.RELATE_WCGW_TO_FLOWCHART_STEP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: flowchartId,
			[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
			[API_RESOURCES.WCGWS]: null
		},
		wcgwData
	);
};

export const unrelateWCGWFromFlowChartStep = (engagementId, flowchartId, flowchartStepId, wcgwId) => {
	return createApiDeleteAction(types.UNRELATE_WCGW_FROM_FLOWCHART_STEP, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.FLOWCHART]: flowchartId,
		[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
		[API_RESOURCES.WCGWS]: wcgwId
	});
};

export const relateItApplicationToFlowChartStep = (engagementId, flowchartId, flowchartStepId, itApplicationData) => {
	return createApiCreateAction(
		types.RELATE_IT_APPLICATION_TO_FLOWCHART_STEP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: flowchartId,
			[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
			[API_RESOURCES.IT_APPLICATIONS]: null
		},
		itApplicationData
	);
};

export const unrelateItApplicationFromFlowChartStep = (engagementId, flowchartId, flowchartStepId, itApplicationId) => {
	return createApiDeleteAction(types.UNRELATE_IT_APPLICATION_FROM_FLOWCHART_STEP, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.FLOWCHART]: flowchartId,
		[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
		[API_RESOURCES.IT_APPLICATIONS]: itApplicationId
	});
};

export const updateStoreRelatedFlowchartStepWCGW = (response) => {
	return {
		type: types.UPDATE_STORE_RELATED_FLOWCHARTSTEPWCGW,
		response
	};
};

export const updateStoreRelatedFlowchartStepITApplication = (response) => {
	return {
		type: types.UPDATE_STORE_RELATED_FLOWCHARTSTEP_IT_APPLICATION_SO,
		response
	};
};

export const updateStoreUnrelatedITApplicationFromFlowchartStep = (response) => {
	return {
		type: types.UPDATE_STORE_UNRELATED_IT_APPLICATION_FROM_FLOWCHARTSTEP_IT_APPLICATION_SO,
		response
	};
};

export const updateStoreUnrelatedWCGWFromFlowchartStep = (response) => {
	return {
		type: types.UPDATE_STORE_UNRELATED_WCGW_FROM_FLOWCHARTSTEPWCGW,
		response
	};
};

export const relateControlToFlowChartStep = (engagementId, flowchartId, flowchartStepId, controlPayload) => {
	return createApiCreateAction(
		types.RELATE_CONTROL_TO_FLOWCHART_STEP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: flowchartId,
			[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
			[API_RESOURCES.CONTROLS]: null
		},
		controlPayload
	);
};

export const updateStoreRelatedFlowchartStepControl = (response) => {
	return {
		type: types.UPDATE_STORE_RELATED_FLOWCHARTSTEP_CONTROL,
		response
	};
};

export const unrelateControlFromFlowChartStep = (engagementId, flowchartId, flowchartStepId, controlId) => {
	return createApiDeleteAction(types.UNRELATE_CONTROL_FROM_FLOWCHART_STEP, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.FLOWCHART]: flowchartId,
		[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
		[API_RESOURCES.CONTROLS]: controlId
	});
};

export const updateStoreUnrelatedControlFromFlowchartStep = (response) => {
	return {
		type: types.UPDATE_STORE_UNRELATED_CONTROL_FROM_FLOWCHARTSTEP_CONTROL,
		response
	};
};

export const clearFlowChartStep = () => {
	return {
		type: types.CLEAR_FLOWCHART_STEP
	};
};

export const relateDocumentToFlowChartStep = (engagementId, flowchartId, flowchartStepId, documentData) => {
	return createApiCreateAction(
		types.RELATE_DOCUMENT_TO_FLOWCHART_STEP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: flowchartId,
			[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
			[API_RESOURCES.DOCUMENTS]: null
		},
		documentData
	);
};

export const unrelateDocumentToFlowChartStep = (engagementId, flowchartId, flowchartStepId, documentId) => {
	return createApiDeleteAction(types.UNRELATE_DOCUMENT_TO_FLOWCHART_STEP, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.FLOWCHART]: flowchartId,
		[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
		[API_RESOURCES.DOCUMENTS]: documentId
	});
};
